import React from 'react'
import clsx from 'clsx'

import DebugMenu from '../../DebugMenu'

import useStyles from './styles'
import { useHistory } from 'react-router-dom'
import { Routes } from '@SonarCX/Routes'

const LogoBlock = ({ className }) => {
  const history = useHistory()
  const [debugging, setDebugging] = React.useState(false)

  const classes = useStyles()

  const location = window.location.href
  // Using just 300 in case server start on 3000 or 3001
  const allowDebug = location.includes('localhost:300')

  const handleOnClick = () => {
    if (allowDebug) {
      setDebugging(true)
    } else {
      history.push(Routes.DASHBOARD)
    }
  }

  return (
    <>
      <div className={clsx(classes.root, className)}>
        <div onClick={handleOnClick} className={classes.logo}>
          <img
            src='/imgs/sidenavV2logo.png'
            alt='Logo'
            className={classes.img}
          />
        </div>
      </div>

      {debugging && <DebugMenu onClose={() => setDebugging(false)} />}
    </>
  )
}

export default LogoBlock
